export default [
  "destinc", "startc"
];
